import React, { useState } from "react";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import Styles from "../../Shared/sharedStyles.module.scss";
import { StyledButton } from "../../../../../Shared/button/button";
import { buttonStyles } from "../../../../../Shared/button/button";
import { convertBase64 } from "../../../../../utils/convertToBase64";
import { testIdProps } from "../../../../../utils/testIdProps";

const validExtensions = ["jpg", "jpeg", "png", "webp", "tiff"];

function FaceLivenessPopup({
  handleResponse,
  name,
  faceLivenessFetch,
  apiResponse,
}: any) {
  const errorObject = {
    consentError: false,
    faceError: false,
    wrongExtensionImage: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [faceMatch, setFaceMatch] = useState(false);
  const [userFaceMatchBase64, setUserFaceMatchBase64] =
    useState<string>("");
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);

  function handleCheck() {
    const consent = isChecked === true ? "Y" : "N";
    const face_match = userFaceMatchBase64;

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }

    if (faceMatch && face_match === "") {
      setError(() => ({
        ...error,
        faceError: true,
      }));

      return false;
    }

    setLoading(true);
    handleResponse({ consent, face_match }, setLoading);
  }

  const uploadImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop()?.toLowerCase();
    if (!fileExtension || !validExtensions.includes(fileExtension)) {
      setError((prevError) => ({
        ...prevError,
        wrongExtensionImage: true,
      }));
      e.target.value = ""; // Clear the file input
      return;
    }

    setError((prevError) => ({
      ...prevError,
      wrongExtensionImage: false,
    }));

    let baseValue64 = (await convertBase64(file)) as string;

    // Remove the Base64 prefix if needed (e.g., data:image/jpeg;base64,)
    // const char = "base64,";
    // const index = baseValue64.indexOf(char);

    // if (index !== -1) {
    //   baseValue64 = baseValue64.substring(index + 1);
    // }

    baseValue64 = baseValue64?.split("base64,")?.[1];

    if (!baseValue64) return;

    setUserFaceMatchBase64(baseValue64);
  };

  const handleFetchWebhookData = () => {
    if (!apiResponse) return;

    let parsedResponse = apiResponse;
    if (typeof apiResponse === "string") {
      try {
        parsedResponse = JSON.parse(apiResponse);
      } catch (error) {
        return null;
      }
    }

    const reqId = parsedResponse?.result?.request_id || null;
    if (!reqId) {
      return;
    }

    setFetchLoading(true);
    faceLivenessFetch(reqId, setFetchLoading);
  };

  return (
    <main className={`${Styles.content}`}>
      <section className={`${Styles.infoForm} pl-2`}>
        <div className="d-flex flex-column">
          <div className="d-flex align-content-center gap-2 mt-4">
            <input
              {...testIdProps("face-match-required-checkbox")}
              type="checkbox"
              className={`${Styles.formCheckInput} `}
              onChange={(e: any) => {
                setFaceMatch(e.target.checked);
              }}
            />
            <p className={`${Styles.ackText}  mb-0`}>
              Is face match required ?
            </p>
          </div>

          {faceMatch && (
            <div className="d-flex">
              {userFaceMatchBase64 ? (
                <div className="d-flex flex-column justify-content-center align-items-center">
                  {/* Show image preview */}
                  <img
                    src={`data:image/jpeg;base64,${userFaceMatchBase64}`}
                    alt="Uploaded face"
                    style={{
                      width: "220px",
                      height: "220px",
                      objectFit: "cover",
                      borderRadius: 8,
                      marginBottom: 8,
                      border: "1px solid #e8e8e8",
                      marginTop: "8px",
                    }}
                  />
                  {/* Show base64 in a textarea for easier viewing/copying */}
                  {/* <textarea
                    value={userFaceMatchBase64}
                    readOnly
                    style={{
                      border: "1px solid #e8e8e8",
                      borderRadius: 8,
                      backgroundColor: "#f8f8f8",
                      width: "200px",
                      height: "60px",
                      marginBottom: 8,
                      resize: "none",
                      fontSize: "10px",
                    }}
                  /> */}
                  <StyledButton
                    hoverStyle={{
                      ...buttonStyles.primary.hover,
                      width: "200px",
                      height: "40px",
                    }}
                    disabled={loading}
                    style={{
                      ...buttonStyles.primary.normal,
                      width: "200px",
                      height: "40px",
                    }}
                    onClick={() => {
                      setUserFaceMatchBase64("");
                      setError((prevError) => ({
                        ...prevError,
                        wrongExtensionImage: false,
                      }));
                    }}
                    id="id-select-new-image-estamp"
                  >
                    Select New Image
                  </StyledButton>
                </div>
              ) : (
                <div
                  style={{
                    width: "220px",
                    height: "220px",
                    border: "1px solid #e8e8e8",
                    borderRadius: "8px",
                    padding: "8px",
                    backgroundColor: "#f8f8f8",
                    marginTop: "8px",
                    cursor: "pointer",
                  }}
                  className="ml-2 d-flex flex-column align-items-center justify-content-center"
                >
                  <label
                    htmlFor="id-input-file-estamp"
                    style={{ cursor: "pointer" }}
                    className={`${Styles.label} mt-2 fs-5 `}
                  >
                    Upload Image
                  </label>
                  <input
                    id="id-input-file-estamp" data-testid="id-input-file-estamp"
                    className={Styles.fileUpload}
                    style={{
                      width: "180px",
                      marginTop: "8px",
                      cursor: "pointer",
                    }}
                    type="file"
                    name="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={uploadImage}
                  />
                  {error.wrongExtensionImage && (
                    <ErrorMessage>
                      Please select correct Image! Only image files (jpg, jpeg,
                      png) are allowed.
                    </ErrorMessage>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="pl-4 pb-4 mt-4 d-flex gap-2">
          <input
            {...testIdProps("face-liveness-consent-checkbox")}
            type="checkbox"
            className={`${Styles.formCheckInput} `}
            onChange={(e: any) => {
              setIsChecked(e.target.checked);
            }}
          />

          <p
            className={`${Styles.ackText} mb-0`}
            style={{ lineHeight: "1", margin: 0 }}
          >
            I hereby agree, to let zoop.one verify my data for verification
          </p>
          {error.consentError && (
            <ErrorMessage>Please provide consent!</ErrorMessage>
          )}
        </div>
        <div className={`d-flex flex-row gap-2`}>
          <StyledButton
            id="id-submit-button-face-liveness"
            hoverStyle={{ ...buttonStyles.primary.hover }}
            disabled={loading}
            isLoading={loading}
            style={{ ...buttonStyles.primary.normal }}
            onClick={() => {
              setTimeout(() => setError({ ...errorObject }), 2000);
              handleCheck();
            }}
          >
            Run Verification
          </StyledButton>

          {apiResponse && (
            <StyledButton
              id="id-submit-fetch-face-liveness"
              hoverStyle={{ ...buttonStyles.borderLight.hover }}
              disabled={loading}
              isLoading={fetchLoading}
              style={{ ...buttonStyles.borderLight.normal }}
              onClick={() => {
                handleFetchWebhookData();
              }}
            >
              Fetch Response
            </StyledButton>
          )}
        </div>
      </section>
    </main>
  );
}

export default FaceLivenessPopup;
